import { render, staticRenderFns } from "./Steppers.vue?vue&type=template&id=638f8b29&scoped=true&"
import script from "./Steppers.vue?vue&type=script&lang=js&"
export * from "./Steppers.vue?vue&type=script&lang=js&"
import style0 from "./Steppers.vue?vue&type=style&index=0&id=638f8b29&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f8b29",
  null
  
)

export default component.exports